<div class="login-container">
  <!-- Toast Notification -->
  <app-agricola-toast
    [message]="toastMessage"
    [type]="toastType"
    [show]="showToast"
    (close)="hideToast()">
  </app-agricola-toast>

  <!-- Left Section - Image Background -->
  <div class="login-left">
    <img src="assets/agricola/login-agricola.webp" alt="" aria-hidden="true" class="login-background-image">
  </div>

  <!-- Right Section - Login Form -->
  <div class="login-right">
    <div class="login-form-container">
      <!-- Logo -->
      <div class="logo-container">
        <img src="assets/agricola/agricola-logo.svg" alt="Bancoagrícola" class="logo-image">
      </div>

      <!-- Title and Subtitle -->
      <h1 class="login-title">Iniciar Sesión</h1>
      <div class="login-subtitle">
        <span class="subtitle-line subtitle-regular">Sistema integral</span>
        <span class="subtitle-line subtitle-bold">de Seguros</span>
      </div>

      <div class="login-form">
        <button
          type="button"
          class="login-button"
          [disabled]="isLoading"
          (click)="loginWithMicrosoft()">
          Login with Microsoft
        </button>
      </div>
    </div>
  </div>
</div>
